<template>
    <v-container>
        <v-row>
            <v-col>
                <v-toolbar rounded="" color="secondary" dense elevation="1">
                    <v-breadcrumbs class="ms-n6" :items="[{text: 'Warehouse & Inventory'}, {text: 'Measure Unit'} ,{text: 'Create Measure Unit',}]" large/>
                    <v-spacer></v-spacer>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-sheet elevation="1" rounded="">
                    <v-toolbar flat color="secondary">
                        <v-toolbar-title>
                            Create Measure Unit
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <PIconBtn icon="mdi-content-save" tooltip="Save" @click="handleSave"/>
                            <PIconBtn icon="mdi-format-list-text" tooltip="List" @click="navigateToList" />
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-progress-linear indeterminate v-if="loading"/>
                    <v-divider></v-divider>
                    <v-row>
                        <v-col >
                            <MeasureUnitForm ref="form" v-model="form" class="pa-3"/>
                        </v-col>
                    </v-row>
                </v-sheet>
            </v-col>
        </v-row>
        <PAlert v-bind="alert" v-model="alert.value"/>
    </v-container>
</template>

<script>
import {mapActions} from 'vuex'
import MeasureUnitForm from './../../components/warehouse/MeasureUnitForm';
import PIconBtn from "./../../components/common/PIconBtn";
import PAlert from "./../../components/common/PAlert.vue";
export default {
    name: "MeasureUnitCreateView",
    components: {
        PIconBtn,
        MeasureUnitForm,
        PAlert
    },
    data() {
        return {
            form : null,
            loading : false ,
            alert: {
                value: false,
                title: "Alert",
                content: "Are you sure",
                callback: null
            },
        }
    },
    methods: {
        ...mapActions({
            create: "warehouse/measureUnit/create",
            snackbar: "ui/snackbar/show"
        }),
        handleSave() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to Save?", callback: this.save};
        },
        save() {
            if(!this.$refs.form.validate()) return ;
            this.loading = true
            this.create(this.form).then(response => {
                this.snackbar({ color: "success", text: "Measure Unit Created" })
                this.$router.push({ name: "MeasureUnitDisplay", params: {id: response.data.id}})
            }).catch(error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({color: 'error', text: message })
            }).finally(() => {
                this.loading = false;
            })
        },
        navigateToList() {
            this.$router.push({ name: "MeasureUnitList"})
        }
    },
}
</script>

<style>

</style>